var DrmConfigurations = require('./modules/drm/drmConfiguration');
/**
 *
 * @param {String} options.src
 * @param {String} options.flashUri
 * @param {Boolean} [options.autoplay=false]
 * @param {DrmConfigurations|Boolean} [options.drm=false]
 * @param {boolean} [options.forceFlash=false]
 * @returns
 * @constructor
 */

function StarzPlayerConfiguration(options) {
    this.drm = options.drm;
    this.src = options.src;
    // set defaults
    this.forceFlash = options.forceFlash || false;
    this.autoplay = !!(options.autoplay && !!options.autoplay);
    this.content = options.content;
    this.eventHandlers = options.eventHandlers;
    this.user = options.user;
    this.adapter = options.adapter;
    this.recEngine = {
        moduleId: options.recEngine.moduleId,
        parentalControl: options.recEngine.parentalControl
    };
    this.lbCDN = options.lbCDN;
    this._validate();
}

StarzPlayerConfiguration.prototype.asJson = function() {
    return {
        src: this.src,
        forceFlashback: this.forceFlash || false,
        drm: this.drm,
        autoplay: this.autoplay
    };
};

StarzPlayerConfiguration.prototype._validate = function() {
    // Todo: implement!
};

module.exports = StarzPlayerConfiguration;



// WEBPACK FOOTER //
// ./src/starzplayer_configuration.js